import React from "react";
import { X } from "lucide-react";
import type { CatalogDocument } from "../hooks/useDocumentMention";
import "./DocumentChips.css";

interface DocumentChipsProps {
	docs: CatalogDocument[];
	onRemove: (docId: string) => void;
}

const DocumentChips: React.FC<DocumentChipsProps> = ({ docs, onRemove }) => {
	if (docs.length === 0) return null;

	return (
		<div className="flex flex-wrap gap-1.5 px-3 pt-2">
			{docs.map((doc) => (
				<span
					key={doc.doc_id}
					className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-[#004C4B1A] text-[#004C4B] text-xs font-medium max-w-[200px]"
				>
					<span className="truncate">
						{doc.ref_type === "deal" ? `Deal: ${doc.filename}` : doc.filename}
					</span>
					<button
						type="button"
						onClick={() => onRemove(doc.doc_id)}
						className="flex-shrink-0 hover:text-[#003332] transition-colors"
						aria-label={`Remove ${doc.filename}`}
					>
						<X size={12} />
					</button>
				</span>
			))}
		</div>
	);
};

export default DocumentChips;
